import { AuxiliumComponent } from "../auxilium-component";

export default class DropdownHeader extends AuxiliumComponent {
	static observable = ["size"];

	constructor() {
		super();

		this.size ??= "5";
	}

	parsedCallback() {
		this.appendChild(document.createElementWithContents("chip-header", this.childNodes, { size: this.size }));
	}
}
